import { EBINQUIRY, RESPONSEDATA } from "app/shared/services/services-model.type";
import {
  FETCH_TOP_UP_INFO_REQUEST,
  FETCH_TOP_UP_INFO_SUCCESS,
  FETCH_TOP_UP_INFO_FAILURE,
  FETCH_TOP_UP_CREATE_REQUEST,
  FETCH_TOP_UP_CREATE_SUCCESS,
  FETCH_TOP_UP_CREATE_FAILURE,
  FETCH_TOP_UP_CONFIRM_REQUEST,
  FETCH_TOP_UP_CONFIRM_SUCCESS,
  FETCH_TOP_UP_CONFIRM_FAILURE,
  FETCH_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  FETCH_TOP_UP_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TOP_UP_AUTHORIZATION_KEY_FAILURE,
  SET_TOP_UP_STORE,
  SET_TOP_UP_RESET,
  FETCH_TOP_UP_CUSTOMER_INFO_REQUEST,
  FETCH_TOP_UP_CUSTOMER_INFO_SUCCESS,
  FETCH_TOP_UP_CUSTOMER_INFO_FAILURE,
  FETCH_TOP_UP_MAKE_FEE_REQUEST,
  FETCH_TOP_UP_MAKE_FEE_FAILURE,
  FETCH_TOP_UP_MAKE_FEE_SUCCESS,
} from "./actions.type";
import {
  FetchTopUpCreateRequest,
  FetchTopUpCreateSuccess,
  FetchTopUpCreateFailure,
  FetchTopUpConfirmRequest,
  FetchTopUpConfirmSuccess,
  FetchTopUpConfirmFailure,
  FetchTopUpAuthorizationRequest,
  FetchTopUpAuthorizationSuccess,
  FetchTopUpAuthorizationFailure,
  DataTopUpCreate,
  SetTopUpStore,
  TopUpState,
  SetTopUpReset,
  FetchTopUpCustomerInfoRequest,
  FetchTopUpCustomerInfoSuccess,
  FetchTopUpCustomerInfoFailure,
  FetchTopUpInfoRequest,
  FetchTopUpInfoSuccess,
  FetchTopUpInfoFailure,
  FetchTopUpMakeFeeRequest,
  FetchTopUpMakeFeeFailure,
  FetchTopUpMakeFeeSuccess,
} from "./types";

export const fetchTopUpInfoRequest = (payload?: string): FetchTopUpInfoRequest => ({
  type: FETCH_TOP_UP_INFO_REQUEST,
  payload,
});

export const fetchTopUpInfoSuccess = (payload?: RESPONSEDATA): FetchTopUpInfoSuccess => ({
  type: FETCH_TOP_UP_INFO_SUCCESS,
  payload,
});

export const fetchTopUpInfoFailure = (payload?: string): FetchTopUpInfoFailure => ({
  type: FETCH_TOP_UP_INFO_FAILURE,
  payload,
});

export const fetchTopUpCreateRequest = (payload: DataTopUpCreate): FetchTopUpCreateRequest => ({
  type: FETCH_TOP_UP_CREATE_REQUEST,
  payload,
});

export const fetchTopUpCreateSuccess = (payload?: RESPONSEDATA): FetchTopUpCreateSuccess => ({
  type: FETCH_TOP_UP_CREATE_SUCCESS,
  payload,
});

export const fetchTopUpCreateFailure = (payload?: string): FetchTopUpCreateFailure => ({
  type: FETCH_TOP_UP_CREATE_FAILURE,
  payload,
});

export const fetchTopUpConfirmRequest = (payload?: RESPONSEDATA): FetchTopUpConfirmRequest => ({
  type: FETCH_TOP_UP_CONFIRM_REQUEST,
  payload,
});

export const fetchTopUpConfirmSuccess = (payload?: RESPONSEDATA): FetchTopUpConfirmSuccess => ({
  type: FETCH_TOP_UP_CONFIRM_SUCCESS,
  payload,
});

export const fetchTopUpConfirmFailure = (payload?: string): FetchTopUpConfirmFailure => ({
  type: FETCH_TOP_UP_CONFIRM_FAILURE,
  payload,
});

export const fetchTopUpAuthorizationRequest = (payload?: RESPONSEDATA, code?: string): FetchTopUpAuthorizationRequest => ({
  type: FETCH_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchTopUpAuthorizationSuccess = (payload?: RESPONSEDATA): FetchTopUpAuthorizationSuccess => ({
  type: FETCH_TOP_UP_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTopUpAuthorizationFailure = (errorOTP: boolean, payload?: string): FetchTopUpAuthorizationFailure => ({
  type: FETCH_TOP_UP_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});

export const setTopUpStore = (payload: TopUpState): SetTopUpStore => ({
  type: SET_TOP_UP_STORE,
  payload,
});

export const setTopUpReset = (): SetTopUpReset => ({
  type: SET_TOP_UP_RESET,
});

// TopUp Detail Account
export const fetchTopUpCustomerInfoRequest = (payload: DataTopUpCreate): FetchTopUpCustomerInfoRequest => ({
  type: FETCH_TOP_UP_CUSTOMER_INFO_REQUEST,
  payload,
});

export const fetchTopUpCustomerInfoSuccess = (payload?: EBINQUIRY): FetchTopUpCustomerInfoSuccess => ({
  type: FETCH_TOP_UP_CUSTOMER_INFO_SUCCESS,
  payload,
});

export const fetchTopUpCustomerInfoFailure = (payload?: string): FetchTopUpCustomerInfoFailure => ({
  type: FETCH_TOP_UP_CUSTOMER_INFO_FAILURE,
  payload,
});

// Tính phí
export const fetchTopUpMakeFeeRequest = (payload: DataTopUpCreate): FetchTopUpMakeFeeRequest => ({
  type: FETCH_TOP_UP_MAKE_FEE_REQUEST,
  payload,
});

export const fetchTopUpMakeFeeFailure = (payload?: string): FetchTopUpMakeFeeFailure => ({
  type: FETCH_TOP_UP_MAKE_FEE_FAILURE,
  payload,
});

export const fetchTopUpMakeFeeSuccess = (payload?: RESPONSEDATA): FetchTopUpMakeFeeSuccess => ({
  type: FETCH_TOP_UP_MAKE_FEE_SUCCESS,
  payload,
});
